import { Button, Group, SimpleGrid, Stack, TextInput } from '@mantine/core';
import { IconUserPlus } from '@tabler/icons-react';
import type { Shema } from '../api/odjemalec';
import { razdeliIme } from '../osebe/vrste';
import { IzbiraOsebe } from '../vozila/IzbiraOsebe';
import type { NovaStranka } from './stranka';

type Oseba = Shema['OsebaPodatki'];

/**
 * Stranka naloga (obvezna): izbira obstoječe ali »Nova stranka« z imenom, priimkom, telefonom in e-pošto. Nova se
 * ustvari, ko se nalog shrani ({@link ustvariStranko}) – gumba »Dodaj« ni treba klikniti. Davčna in naslov se
 * dopolnita kasneje na zaslonu osebe. »Nov kupec« v izbiri odpre isti obrazec z imenom iz iskanja.
 */
export function StrankaNaloga({
  kupec,
  izberi,
  nova,
  nastaviNovo,
  polja,
}: {
  kupec: Oseba | null;
  izberi: (o: Oseba | null) => void;
  nova: NovaStranka;
  nastaviNovo: (n: NovaStranka) => void;
  polja: Record<string, string>;
}) {
  if (nova) {
    const polje = (k: keyof NonNullable<NovaStranka>, oznaka: string, vrsta?: string) => (
      <TextInput
        label={oznaka}
        type={vrsta}
        value={nova[k]}
        onChange={(e) => nastaviNovo({ ...nova, [k]: e.currentTarget.value })}
        onBlur={() => nastaviNovo({ ...nova, [k]: nova[k].trim() })}
        error={k === 'ime' ? (polja['stranka.ime'] ?? polja.kupecId) : undefined}
        withAsterisk={k === 'ime'}
      />
    );
    return (
      <Stack gap="sm">
        <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="sm">
          {polje('ime', 'Ime')}
          {polje('priimek', 'Priimek')}
          {polje('telefon', 'Telefon', 'tel')}
          {polje('email', 'E-pošta', 'email')}
        </SimpleGrid>
        <Group>
          <Button variant="subtle" onClick={() => nastaviNovo(null)}>
            Izberi vpisano stranko
          </Button>
        </Group>
      </Stack>
    );
  }
  return (
    <Stack gap="sm">
      <IzbiraOsebe
        vrsta="kupci"
        oznaka="Stranka"
        izbran={kupec}
        izberi={izberi}
        napaka={polja.kupecId}
        dodaj={(iskanje) => {
          izberi(null);
          nastaviNovo({ ...razdeliIme(iskanje), telefon: '', email: '' });
        }}
      />
      {!kupec && (
        <Group>
          <Button
            variant="light"
            leftSection={<IconUserPlus size={18} />}
            onClick={() => nastaviNovo({ ime: '', priimek: '', telefon: '', email: '' })}
          >
            Nova stranka
          </Button>
        </Group>
      )}
    </Stack>
  );
}
